import { AppConfig, getShipImages, getShipVideos } from '@config'
import type { ShipOwnerVideo } from '@shared_types/data_files/index_json_types'
import { isNonEmptyArray } from '@shared_utils/array_utils'
import { useMemo } from 'react'

import { getServerUrl } from './useApi'

interface DemoMedia {
  img: string
  video: ShipOwnerVideo
  model: string
}

export function useDemoMedia () {
  const mediaItemSource = useMemo(
    () => ({
      img: getShipImages(),
      videos: getShipVideos(),
      model: AppConfig['3d'].demo() || ''
    }),
    []
  )

  const activeVideo = mediaItemSource.videos.find(video => video.isActive)

  const demoMedia: DemoMedia = {
    img: isNonEmptyArray(mediaItemSource.img) ? getServerUrl(mediaItemSource.img[0]) : '',
    video: {
      path: '',
      title: '',
      isHorizontal: true,
      isActive: false
    },
    model: mediaItemSource.model.length > 0 && mediaItemSource.model !== 'None' ? mediaItemSource.model : ''
  }

  if (activeVideo) {
    demoMedia.video.path = getServerUrl(activeVideo.path)
    demoMedia.video.isHorizontal = activeVideo.isHorizontal
    demoMedia.video.title = activeVideo.title
    demoMedia.video.isActive = activeVideo.isActive
  }

  return { demoMedia }
}
